import classNames from "classnames";
import { useEffect, useRef, useState } from "react";

import "./index.scss";
import DropDownLoading from "../DropDownLoading";

type Props = {
  size?: "medium" | "large";
  items: any[];
  label?: string;
  itemName: string;
  isRequired?: boolean;
  inputWidth?: number;
  defaultItem?: any;
  placeHolder: string;
  onSelectItem: (item: any) => void;
  searchPlaceHolder?: string;
  isSearch?: boolean;
  isLoading?: boolean;
  nullable?: boolean;
};

const CustomDropDownSearch: React.FC<Props> = ({
  size = "medium",
  label,
  items,
  itemName,
  isRequired,
  inputWidth,
  defaultItem,
  placeHolder,
  onSelectItem,
  searchPlaceHolder,
  isSearch,
  isLoading,
  nullable = true,
}) => {
  const selectSearchRef = useRef<HTMLInputElement | null>(null);
  const [isActiveSearch, setIsActiveSearch] = useState(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [searchedItems, setSearchedItems] = useState<any[]>(items);

  useEffect(() => setSearchedItems(items), [items]);
  useEffect(() => {
    document.addEventListener("mousedown", (event: any) => {
      if (!selectSearchRef?.current?.contains(event.target)) {
        setIsActiveSearch(false);
      }
    });
  }, []);

  function onChangeSearch(value: string) {
    setSearchedItems(
      items.filter((item: any) => item[itemName].includes(value))
    );
  }
  return (
    <section id="custom_dropdown" ref={selectSearchRef}>
      {label && (
        <div className="input-label">
          {label}
          {isRequired && (
            <i
              className={classNames(
                "fa-solid fa-star-of-life",
                "important-star"
              )}
            ></i>
          )}
        </div>
      )}
      <div
        className={classNames("dd-selection-container", `${size}`)}
        style={{ width: inputWidth }}
        onClick={(e) => setIsActiveSearch(!isActiveSearch)}
      >
        <div className="selection-value">
          <div className="remove-select-button">
            {defaultItem && defaultItem[itemName] !== null && nullable && (
              <i
                onClick={() => onSelectItem(null)}
                className="fa-solid fa-xmark"
              />
            )}
          </div>
          <div className="default-text">
            {defaultItem && defaultItem[itemName] !== null
              ? defaultItem[itemName]
              : placeHolder}
          </div>
        </div>
        {isActiveSearch ? (
          <i className="fa-solid fa-chevron-up"></i>
        ) : (
          <i className="fa-solid fa-chevron-down"></i>
        )}
      </div>

      {isActiveSearch && (
        <div className="dd-content-container">
          {isLoading && <DropDownLoading />}

          {isSearch && !isLoading && (
            <div className="dd-search-container">
              <input
                className="dds-search-input"
                type="text"
                maxLength={20}
                placeholder={searchPlaceHolder}
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.currentTarget.value);
                  onChangeSearch(e.currentTarget.value);
                }}
              />
              {searchValue !== "" && (
                <i
                  className="fa-solid fa-xmark"
                  onClick={() => {
                    onChangeSearch("");
                    setSearchValue("");
                  }}
                />
              )}
            </div>
          )}
          <div className="items-container">
            {searchedItems?.map((item, index) => (
              <div
                key={`item-${index}`}
                className={classNames(
                  defaultItem && defaultItem._id === item._id
                    ? "dd-content-selected"
                    : "dd-content-value"
                )}
                onClick={() => {
                  onSelectItem(item);
                  setIsActiveSearch(false);
                }}
              >
                <span>{item[itemName]}</span>
                {defaultItem && defaultItem?._id === item._id && (
                  <i className="fa-solid fa-check" />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default CustomDropDownSearch;
